import { motion, useReducedMotion } from "framer-motion";
import { DEFAULT_ASSISTANT_NAME } from "@/utils/assistant-name";

export function SplashScreen() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center !bg-white backdrop-blur-none pointer-events-none">
      <div className="relative w-48 h-48 flex items-center justify-center">
        <div
          aria-hidden
          className="absolute inset-0 rounded-2xl border-4 border-border-strong/50 animate-spin transform-gpu"
          style={{
            animationDuration: "3s",
            animationTimingFunction: "linear",
            willChange: "transform, opacity",
            opacity: prefersReducedMotion ? 0.4 : 1,
          }}
        />
        <div
          aria-hidden
          className="absolute inset-0 rounded-2xl border-2 border-border/80 animate-spin transform-gpu"
          style={{
            animationDuration: "3s",
            animationTimingFunction: "linear",
            animationDirection: "reverse",
            willChange: "transform, opacity",
            opacity: prefersReducedMotion ? 0.5 : 1,
          }}
        />
        <div
          aria-hidden
          className="absolute inset-0 rounded-2xl border border-border-subtle animate-spin transform-gpu"
          style={{
            animationDuration: "2s",
            animationTimingFunction: "linear",
            willChange: "transform, opacity",
            opacity: prefersReducedMotion ? 0.6 : 1,
          }}
        />

        

        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={prefersReducedMotion ? { opacity: 1 } : { opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
          className="relative z-10"
          style={{ willChange: "transform, opacity" }}
        >
          <span className="select-none text-[26px] leading-none font-semibold tracking-tight text-neutral-950">{DEFAULT_ASSISTANT_NAME}</span>
        </motion.div>
      </div>

      <div className="absolute bottom-16 text-sm font-medium text-text-muted">
        <div className={prefersReducedMotion ? "" : "animate-pulse"} style={{ willChange: "opacity" }}>
          Loading...
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
